import { inject, Injectable } from '@angular/core';
import { environment } from '@shared/environments';
import { KeycloakService } from 'keycloak-angular';
import { BrowserDataStore } from '../browser';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private readonly keycloakService = inject(KeycloakService);
  private readonly browserData = inject(BrowserDataStore);

  userProfileUrl = `https://${environment.keycloak?.url}/auth/realms/${environment.keycloak?.realm}/account/#/personal-info`;

  logout(url?: string): Promise<void> {
    return this.keycloakService.logout(url ?? document.location.origin);
  }

  goToLogin(url?: string): Promise<void> {
    this.browserData.saveAuthenticated(false);

    return this.keycloakService
      .login({
        redirectUri: url ? url : `${document.location.origin}/sites`,
      })
      .then(() => {
        console.log('success auth');
      });
  }
}
